// extracted by mini-css-extract-plugin
export default {"center":"styles_center__8d4Ru","text":"styles_text__DV8kd"};